var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgImage = function SvgImage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M16.5 10.5a3 3 0 1 0 0-6 3 3 0 0 0 0 6m0-1.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M1.5 15.75v3.75a3 3 0 0 0 3 3h15a3 3 0 0 0 3-3v-15a3 3 0 0 0-3-3h-15a3 3 0 0 0-3 3zM19.5 3h-15A1.5 1.5 0 0 0 3 4.5v9.44l3.97-3.97a.75.75 0 0 1 1.06 0L12 13.94l1.72-1.72a.75.75 0 0 1 1.06 0L21 18.44V4.5A1.5 1.5 0 0 0 19.5 3m1.258 17.318-6.508-6.507-1.72 1.72a.75.75 0 0 1-1.06 0L7.5 11.56 3 16.06V19.5A1.5 1.5 0 0 0 4.5 21h15c.527 0 .99-.271 1.258-.682",
    clipRule: "evenodd"
  })));
};
export default SvgImage;